// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f6f95e3a","453":"62e93fe5","455":"94b0b7f9","977":"dc937b14"}[chunkId] + ".chunk.js";
};